<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(family_submit)" @reset.prevent="reset" >
              <!-- <h4>{{ $t('educational_management.present_business_address') }}</h4> -->
            <template>
                <div style="font-size:18px; background-color: #005B5B;">
                    <h5 class="text-white text-center"> {{ $t('educational_management.present_business_address') }}
                    </h5>
                </div>
            </template>
            <!-- Presemt Address Section -->
              <b-row class="mt-2">
                <!-- address start -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="Area Type" vid="pre_area_type_id" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pre_area_type_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.area_type')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pre_area_type_id"
                          :options="areaTypeList"
                          id="pre_area_type_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Division -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="Division" vid="pre_division_id" rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="pre_division_id"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="address_family_info.pre_division_id"
                        :options="divisionList"
                        id="pre_division_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- District -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="District" vid="pre_district_id" rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="pre_district_id"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="address_family_info.pre_district_id"
                        :options="preDistrictList"
                        id="pre_district_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- City Corporation -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-if="address_family_info.pre_area_type_id === 1">
                    <ValidationProvider name="City Corporation" vid="pre_city_corporation_id" :rules="`${pre_cityCorporationShow ? 'required' : ''}`">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pre_city_corporation_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.city_corporation')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pre_city_corporation_id"
                          :options="preCityCorporationList"
                          id="pre_city_corporation_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Upazila -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-if="address_family_info.pre_area_type_id === 3">
                    <ValidationProvider name="Upazila" vid="pre_upazilla_id" :rules="`${pre_upazilaShow ? 'required' : ''}`">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pre_upazilla_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.upazila')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pre_upazilla_id"
                          :options="preUpazilaList"
                          id="pre_upazilla_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Union -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-if="address_family_info.pre_area_type_id === 3">
                    <!-- <ValidationProvider name="Union" vid="pre_union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Union" vid="pre_union_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pre_union_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.union')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pre_union_id"
                          :options="preUnionList"
                          id="pre_union_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Pourashava -->
                  <b-col xl="4" lg="4" sm="12" v-if="address_family_info.pre_area_type_id === 2">
                    <!-- <ValidationProvider name="Pourashava" vid="pre_pauroshoba_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Pourashava" vid="pre_pauroshoba_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pre_pauroshoba_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.pourashava')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pre_pauroshoba_id"
                          :options="prePauroshobaList"
                          id="pre_pauroshoba_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Ward -->
                  <b-col xl="4" lg="4" sm="12">
                    <!-- <ValidationProvider name="Ward" vid="pre_ward_id" :rules="`${wardShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Ward" vid="pre_ward_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pre_ward_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('org_pro.ward') }}
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pre_ward_id"
                          :options="preWardList"
                          id="pre_ward_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- address end -->
              </b-row>
              <b-row>
                  <b-col lg="6"  sm="12">
                      <ValidationProvider name="Present Address (Bn)" vid="present_address_bn" rules="required">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="present_address_bn"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('social_service.house_road_bn')}} <span class="text-danger">*</span>
                              </template>
                            <b-form-textarea
                                id="present_address_bn"
                                v-model="address_family_info.present_address_bn"
                                rows="1"
                                max-rows="2"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-textarea>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
                  <b-col lg="6"  sm="12">
                      <ValidationProvider name="Present Address" vid="present_address" rules="required">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="present_address"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('social_service.house_road_en')}} <span class="text-danger">*</span>
                              </template>
                            <b-form-textarea
                                id="present_address"
                                v-model="address_family_info.present_address"
                                rows="1"
                                max-rows="2"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-textarea>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
              </b-row>
            <template>
                <div style="font-size:18px; background-color: #005B5B;">
                    <h5 class="text-white text-center"> {{ $t('educational_management.permanent_address') }}
                    </h5>
                </div>
            </template>
              <!-- Permament Address Section -->
              <b-row class="mt-2">
                <!-- address start -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="Area Type" vid="area_type_id" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="area_type_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.area_type')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.area_type_id"
                          :options="areaTypeList"
                          id="area_type_id"
                          @change="getAreaTypeData(address_family_info.area_type_id)"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Division -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="Division" vid="division_id" rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="division_id"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="address_family_info.division_id"
                        :options="divisionList"
                        id="division_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- District -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="District" vid="district_id" rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="district_id"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="address_family_info.district_id"
                        :options="districtList"
                        id="district_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- City Corporation -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-if="address_family_info.area_type_id === 1">
                    <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required' : ''}`">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="city_corporation_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.city_corporation')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.city_corporation_id"
                          :options="cityCorporationList"
                          id="city_corporation_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Upazila -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-if="address_family_info.area_type_id === 3">
                    <ValidationProvider name="Upazila" vid="upazilla_id" :rules="`${upazilaShow ? 'required' : ''}`">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="upazilla_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.upazila')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.upazilla_id"
                          :options="upazilaList"
                          id="upazilla_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Union -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-if="address_family_info.area_type_id === 3">
                    <!-- <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Union" vid="union_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="union_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.union')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.union_id"
                          :options="unionList"
                          id="union_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Pourashava -->
                  <b-col xl="4" lg="4" sm="12" v-if="address_family_info.area_type_id === 2">
                    <!-- <ValidationProvider name="Pourashava" vid="pauroshoba_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Pourashava" vid="pauroshoba_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pauroshoba_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.pourashava')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.pauroshoba_id"
                          :options="pauroshobaList"
                          id="pauroshoba_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Ward -->
                  <b-col xl="4" lg="4" sm="12">
                    <!-- <ValidationProvider name="Ward" vid="ward_id" :rules="`${wardShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Ward" vid="ward_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="ward_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('org_pro.ward') }}
                        </template>
                        <b-form-select
                          plain
                          v-model="address_family_info.ward_id"
                          :options="wardList"
                          id="ward_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- address end -->
              </b-row>
              <b-row>
                  <b-col lg="6"  sm="12">
                      <ValidationProvider name="Premanent Address (Bn)" vid="permanent_address_bn" rules="required">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="permanent_address_bn"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('social_service.house_road_bn')}} <span class="text-danger">*</span>
                              </template>
                            <b-form-textarea
                                id="permanent_address_bn"
                                v-model="address_family_info.permanent_address_bn"
                                rows="1"
                                max-rows="2"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-textarea>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
                  <b-col lg="6"  sm="12">
                      <ValidationProvider name="Premanent Address" vid="permanent_address" rules="required">
                          <b-form-group
                              class="row"
                              label-cols-sm="4"
                              label-for="permanent_address"
                              slot-scope="{ valid, errors }"
                              >
                              <template v-slot:label>
                              {{$t('social_service.house_road_en')}} <span class="text-danger">*</span>
                              </template>
                            <b-form-textarea
                                id="permanent_address"
                                v-model="address_family_info.permanent_address"
                                rows="1"
                                max-rows="2"
                                :state="errors[0] ? false : (valid ? true : null)"
                            ></b-form-textarea>
                              <div class="invalid-feedback">
                              {{ errors[0] }}
                              </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
              </b-row>
               <template>
                <div style="font-size:18px; background-color: #005B5B;">
                    <h5 class="text-white text-center"> {{ $t('social_service.patient_family_info') }}
                    </h5>
                </div>
            </template>
              <!-- <h4>{{ $t('social_service.patient_family_info') }}</h4> -->
            <template >
                <b-overlay>
                    <!-- <ValidationObserver ref="formAddProduct" v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(addProduct)" @reset.prevent="reset"> -->
                          <b-list-group>
                            <b-list-group-item class="d-flex align-items-center">
                              <b-row>
                                <b-col xl="6" lg="4" sm="12">
                                  <ValidationProvider name="Member Name (Bn)" vid="member_name_bn">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="member_name_bn"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                      {{$t('social_service.fam_mem_bn')}}
                                      </template>
                                          <b-form-input
                                          id="member_name_bn"
                                          v-model="family_members.member_name_bn"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                              {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Member Name" vid="member_name">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="member_name"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.fam_mem_en')}}
                                    </template>
                                    <b-form-input
                                        id="member_name"
                                        v-model="family_members.member_name"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Age" vid="age">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="age"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.age')}}
                                    </template>
                                  <b-form-input
                                        id="age"
                                        type="number"
                                        v-model="family_members.age"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Gender" vid="gender">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="gender"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.gender')}}
                                    </template>
                                    <b-form-select
                                      plain
                                      v-model="family_members.gender"
                                      :options="genderList"
                                      id="gender"
                                      :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                  <ValidationProvider name="Qualification" vid="qualification">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="qualification"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                      {{$t('social_service.edu_quali_en')}}
                                      </template>
                                          <b-form-input
                                          id="qualification"
                                          v-model="family_members.qualification"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                              {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                  <ValidationProvider name="Occupation (bn)" vid="occupation_bn">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="occupation_bn"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                      {{$t('social_service.occupation_bn')}}
                                      </template>
                                          <b-form-input
                                          id="occupation_bn"
                                          v-model="family_members.occupation_bn"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                              {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Occupation" vid="occupation">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="occupation"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.occupation_en')}}
                                    </template>
                                    <b-form-input
                                        id="occupation"
                                        v-model="family_members.occupation"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Monthly Income" vid="monthly_income">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="monthly_income"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.monthly_income')}}
                                    </template>
                                  <b-form-input
                                        id="monthly_income"
                                        type="number"
                                        v-model="family_members.monthly_income"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                  <ValidationProvider name="Relation (bn)" vid="relation_bn">
                                      <b-form-group
                                          class="row"
                                          label-cols-sm="4"
                                          label-for="relation_bn"
                                          slot-scope="{ valid, errors }"
                                      >
                                      <template v-slot:label>
                                      {{$t('social_service.relation_bn')}}
                                      </template>
                                          <b-form-input
                                          id="relation_bn"
                                          v-model="family_members.relation_bn"
                                          :state="errors[0] ? false : (valid ? true : null)"
                                          ></b-form-input>
                                          <div class="invalid-feedback">
                                              {{ errors[0] }}
                                          </div>
                                      </b-form-group>
                                  </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Relation" vid="relation">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="relation"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.relation_en')}}
                                    </template>
                                    <b-form-input
                                        id="relation"
                                        v-model="family_members.relation"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Comment (Bn)" vid="comment_bn">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="comment_bn"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.coment_bn')}}
                                    </template>
                                  <b-form-input
                                        id="comment_bn"
                                        v-model="family_members.comment_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="6" lg="4" sm="12">
                                    <ValidationProvider name="Comment" vid="comment">
                                    <b-form-group
                                        class="row"
                                        label-cols-sm="4"
                                        label-for="comment"
                                        slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('social_service.coment_en')}}
                                    </template>
                                  <b-form-input
                                        id="comment"
                                        v-model="family_members.comment"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-form-input>
                                        <div class="invalid-feedback">
                                        {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                                <b-col xl="12" lg="12" sm="6">
                                    <div style="margin-top:15px;">
                                        <b-button variant=" iq-bg-success" size="sm" @click.prevent="addItem()"><i class="ri-add-line mr-1"></i></b-button>
                                    </div>
                                </b-col>
                            </b-row>
                            </b-list-group-item>
                          </b-list-group>
                        <!-- </b-form>
                    </ValidationObserver> -->
                </b-overlay>
              <br>
              <b-row>
                <table class="table table-bordered">
                  <tr style="background-color: #005B5B; color: white;">
                      <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                      <th scope="col">{{ $t('social_service.fam_name') }}</th>
                      <th scope="col">{{ $t('social_service.age') }}</th>
                      <th scope="col">{{ $t('social_service.gender') }}</th>
                      <th scope="col">{{ $t('social_service.occupation') }}</th>
                      <th scope="col">{{ $t('globalTrans.action') }}</th>
                  </tr>
                  <tr v-for="(item, index) in address_family_info.family_info" :key="index">
                      <td>{{ $n(index + 1) }}</td>
                      <td>{{ lang === 'en' ? item.member_name : item.member_name_bn }}</td>
                      <td>{{ $n(item.age) }}</td>
                      <td>{{ getFMGender(item.gender) }}</td>
                      <td>{{ lang === 'en' ? item.occupation : item.occupation_bn }}</td>
                      <td>
                          <button @click="deleteItem(index)" class="btn btn-danger btn-xs"><i class="fa fa-trash"></i></button>
                      </td>
                  </tr>
                  </table>
              </b-row>
            </template>
            </b-form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { AddressFamilyFormCaseHistory } from '../../../api/routes'
import StaticData from './static_data.js'

export default {
  props: ['address_family_info'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      lang: this.$i18n.locale,
      showData: 0,
      showIdType: 0,
      qtyLoad: true,
      loadingPatient: false,
      isSearchInValid: false,
      ItemShow: false,
      pre_cityCorporationShow: false,
      pre_upazilaShow: false,
      pre_unionShow: false,
      pre_pourashavaShow: false,
      pre_wardShow: false,
      cityCorporationShow: false,
      upazilaShow: false,
      unionShow: false,
      pourashavaShow: false,
      wardShow: false,
      preDistrictList: [],
      preUpazilaList: [],
      preUnionList: [],
      preCityCorporationList: [],
      prePauroshobaList: [],
      preWardList: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      wardList: [],
      rows: [],
      areaTypeList: [
        { value: 1, text: this.$t('educational_management.city_corporation') },
        { value: 2, text: this.$t('educational_management.pourosoba') },
        { value: 3, text: this.$t('educational_management.name_of_union') }
      ],
      family_members: {
          member_name: '',
          member_name_bn: '',
          age: '',
          gender: 0,
          qualification: '',
          qualification_bn: '',
          occupation: '',
          occupation_bn: '',
          monthly_income: '',
          relation: '',
          relation_bn: '',
          comment: '',
          comment_bn: ''
      },
      sl: 0,
      mobile_list: [],
      email_list: [],
      message_en_list: [],
      message_bn_list: [],
      mobile_list_input: '',
      email_list_input: '',
      message_en_list_input: '',
      message_bn_list_input: ''
    }
  },
  mounted () {
    core.index()
  },
  created () {
    if (this.$route.params.case_id) {
      this.address_family_info.family_info.push(JSON.parse(JSON.stringify(this.family_members)))
    }
    this.getDistrictList()
    this.getUpazilaList()
    this.getUnionList()
    this.getCityCorporationList()
    this.getPauroshobaList()
  },
  watch: {
    'address_family_info.pre_division_id': function (newVal, oldVal) {
      this.preDistrictList = this.getPreDistrictList(parseInt(newVal))
    },
    'address_family_info.pre_district_id': function (newVal, oldVal) {
      this.preCityCorporationList = this.getCityCorporationList(parseInt(newVal))
      this.preUpazilaList = this.getPreUpazilaList(parseInt(newVal))
    },
    'address_family_info.pre_upazilla_id': function (newVal, oldVal) {
      this.preUnionList = this.getPreUnionList(parseInt(newVal))
      this.prePauroshobaList = this.getPrePauroshobaList(parseInt(newVal))
    },
    'address_family_info.pre_city_corporation_id': function (newVal, oldVal) {
      this.preWardList = this.getPreWardListByCityCorportaion(parseInt(newVal))
    },
    'address_family_info.pre_pauroshoba_id': function (newVal, oldVal) {
      this.preWardList = this.getPreWardListByPauroshoba(parseInt(newVal))
    },
    'address_family_info.pre_union_id': function (newVal, oldVal) {
      this.preWardList = this.getPreWardListByUnion(parseInt(newVal))
    },
    'address_family_info.area_type_id': function (newVal, oldVal) {
        // this.officeList = this.getlocation(newVal)
        this.getAreaTypeData(newVal)
    },
    'address_family_info.division_id': function (newVal, oldVal) {
      this.districtList = this.getDistrictList(parseInt(newVal))
    },
    'address_family_info.district_id': function (newVal, oldVal) {
      this.cityCorporationList = this.getCityCorporationList(newVal)
      this.upazilaList = this.getUpazilaList(parseInt(newVal))
    },
    'address_family_info.upazilla_id': function (newVal, oldVal) {
      this.unionList = this.getUnionList(parseInt(newVal))
      this.pauroshobaList = this.getPauroshobaList(parseInt(newVal))
    },
    'address_family_info.city_corporation_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByCityCorportaion(parseInt(newVal))
    },
    'address_family_info.pauroshoba_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByPauroshoba(parseInt(newVal))
    },
    'address_family_info.union_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByUnion(parseInt(newVal))
    }
  },
  computed: {
    muacList: function () {
      return StaticData.muacList(this)
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    genderList: function () {
      return this.$store.state.commonObj.genderList
    }
  },
  methods: {
    getPreDistrictList (divisionId = null) {
        if (divisionId !== null) {
          return this.$store.state.commonObj.districtList.filter(district => district.division_id === parseInt(divisionId))
        }
    },
    getPreUpazilaList (districtId = null) {
        if (districtId) {
          return this.$store.state.commonObj.upazilaList.filter(upazila => upazila.district_id === parseInt(districtId))
        } else {
          return this.$store.state.commonObj.upazilaList
        }
    },
    getPreUnionList (upazilaId = null) {
        if (upazilaId) {
          return this.$store.state.commonObj.unionList.filter(union => union.upazilla_id === parseInt(upazilaId))
        }
    },
    getPreCityCorporationList (districtId) {
      const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === parseInt(districtId))
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getPrePauroshobaList (upazillaId = null) {
      if (upazillaId) {
          const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === parseInt(upazillaId))
          return objectData
      }
    },
    getPreWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === parseInt(cityCorpId) && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getPreWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === parseInt(pauroshobaId) && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getPreWardListByUnion (unionId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.union_id === parseInt(unionId) && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getDistrictList (divisionId = null) {
        if (divisionId !== null) {
          return this.$store.state.commonObj.districtList.filter(district => district.division_id === parseInt(divisionId))
        } else {
          return this.$store.state.commonObj.districtList
        }
    },
    getUpazilaList (districtId = null) {
        if (districtId) {
          return this.$store.state.commonObj.upazilaList.filter(upazila => upazila.district_id === parseInt(districtId))
        } else {
          return this.$store.state.commonObj.upazilaList
        }
    },
    getUnionList (upazilaId = null) {
        if (upazilaId) {
          return this.$store.state.commonObj.unionList.filter(union => union.upazilla_id === parseInt(upazilaId))
        } else {
          return this.$store.state.commonObj.unionList
        }
    },
    getCityCorporationList (districtId) {
      let objectData = []
        if (districtId) {
          objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === parseInt(districtId))
        } else {
          objectData = this.$store.state.commonObj.cityCorporationList
        }
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getPauroshobaList (upazillaId = null) {
      if (upazillaId) {
          const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === parseInt(upazillaId))
          return objectData
      } else {
        return this.$store.state.commonObj.pauroshobaList
      }
    },
    getWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getWardListByUnion (unionId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getFMGender (id) {
        const gender = this.$store.state.commonObj.genderList.find(gender => gender.value === parseInt(id))
        if (gender) {
          if (this.lang === 'bn') {
            return gender.text_bn
          } else {
            return gender.text_en
          }
        } else {
          return ''
        }
    },
    async family_submit () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      const loadingState = { loading: false, listReload: false }
      this.address_family_info.case_main_id = parseInt(this.$route.params.case_id) > 0 ? parseInt(this.$route.params.case_id) : 0
      var result = await RestApi.postData(hospitalServiceBaseUrl, AddressFamilyFormCaseHistory, this.address_family_info)
      loadingState.listReload = true
      this.$store.dispatch('mutateCommonProperties', loadingState)
      if (result.success) {
        this.$store.commit('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
          this.$toast.success({
            title: 'Success',
            message: this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
          })
          return result
          } else {
            this.$toast.error({
                title: 'Error',
                message: this.$t('globalTrans.form_error_msg'),
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
          }
    },
    addItem () {
            this.family_members.member_name = ''
            this.family_members.member_name_bn = ''
            this.family_members.age = ''
            this.family_members.gender = 0
            this.family_members.qualification = ''
            this.family_members.qualification_bn = ''
            this.family_members.occupation = ''
            this.family_members.occupation_bn = ''
            this.family_members.monthly_income = ''
            this.family_members.relation = ''
            this.family_members.relation_bn = ''
            this.family_members.comment = ''
            this.family_members.comment_bn = ''
          // }
        },
        deleteItem (i) {
            this.address_family_info.family_info.splice(i, 1)
        }
  }
}
</script>
